import * as types from './actionTypes';
import CollectionApi from '../api/mockCollectionApi';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';
import {loadRecipes} from './recipeActions';

//------------------COLLECTIONS FUNCTIONS------------------
export function loadCollectionsSuccess(collections) {
	//debugger;
	return { type: types.LOAD_COLLECTIONS_SUCCESS, collections: collections };
}

//this is a thunk - contains dispatch and promise
export function loadCollections(user) {
	//debugger;
	return function(dispatch) {
		dispatch(beginAjaxCall());
		return CollectionApi.loadCollections(user).then(collections => {
			dispatch(loadCollectionsSuccess(collections));
		}).catch(error => {
			throw(error);
		});
	};
}

//------------------COLLECTION FUNCTIONS------------------
export function loadCollectionSuccess(collection) {
	return {type: types.LOAD_COLLECTION_SUCCESS, collection: collection};
}

export function loadCollection(collection,reloadRecipes) {
	//debugger;
	return function(dispatch) {
		dispatch(beginAjaxCall());
		return CollectionApi.loadCollection(collection).then(collection => {
			dispatch(loadCollectionSuccess(collection));
			if (reloadRecipes != false) {
				//console.log(collection);				
				dispatch(loadRecipes(collection)); //move to second action (? there might be a more preferred way to do this)
			}
		}).catch(error => {
			throw(error);
		});
	};
}


/** WEBPACK FOOTER **
 ** ./src/actions/collectionActions.js
 **/